<!--
 * @description: 
 * @Author: oodoobvideo@gmail.com
 * @Date: 2020-05-20 19:59:10
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-10-06 22:34:39
-->
<template>
  <div class="page_container home">
    <!-- <h3 class="page_title">组件管理</h3> -->
    <div class="main_container_editor">
      <!-- <el-row :gutter="20" justify="space-between"> -->
      <!-- <el-col :span="10"> -->
      <!-- <el-card class="mt20"> -->
      <div class="left">
        <div class="editor_container mt20" v-loading="loading">
          <canvas ref="canvas" width="550" height="550"></canvas>
        </div>
        <div class="bg_container_c">
          <div class="bg_item" v-for="item in bgList" :key="item" @click="loadAndUseBg(item)">
            <img :src="item" alt="" />
          </div>
        </div>
      </div>
      <!-- </el-card> -->
      <!-- </el-col> -->
      <!-- <el-col :span="11"> -->
      <!-- <h3>Parts</h3> -->
      <div class="right">
        <el-card class="mt20">
          <el-tabs v-model="activeName">
            <el-tab-pane label="TEXT" name="text">
              <div class="panel_item">
                <!-- <h4>添加文本</h4> -->
                <el-input size v-model="addingText" placeholder="Your Text">
                  <el-button slot="append" @click="handleAddText">ADD TEXT</el-button>
                </el-input>
              </div>
              <div class="panel_item">
                <!-- <h4>TEXT LISTS</h4> -->
                <div class="component_list_container">
                  <template v-if="dataJson.objects">
                    <template v-for="(object, index) in dataJson.objects">
                      <div class="mb20" :key="index">
                        <ComponentText
                          :object="object"
                          @textChange="handleTextChange"
                          @fontFamilyChange="handleFontFamilyChange"
                          @fontColorChange="handleFontColorChange"
                          @fontCharSpacingChange="handleFontCharSpacingChange"
                          @handleRemove="handleRemove"
                        ></ComponentText>
                      </div>
                    </template>
                  </template>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="SIGN" name="image">
              <div class="category_list">
                <el-button
                  size="small"
                  :type="activeImageTag == 'all' ? 'success' : ''"
                  @click="
                    () => {
                      pagination.current = 0;
                      catgory = '';
                      getList('all');
                    }
                  "
                  key="all"
                  >ALL</el-button
                >
                <template v-for="(item, index) in catgoryList">
                  <el-button
                    size="small"
                    :key="item.id"
                    :type="activeImageTag == index ? 'success' : ''"
                    @click="
                      () => {
                        pagination.current = 0;
                        catgory = item.id;
                        getList(index);
                      }
                    "
                    >{{ item.catgory }}</el-button
                  >
                </template>
              </div>
              <div class="part_image_container mt20">
                <el-input class="mb20" size="small" v-model="keyword">
                  <el-button
                    slot="append"
                    @click="
                      () => {
                        pagination.current = 0;
                        catgory = '';
                        getList();
                      }
                    "
                  >
                    <i class="el-icon-search"></i>
                  </el-button>
                </el-input>
                <div :class="hasPrev ? 'part_image_item' : 'part_image_item disable'" @click="handlePagePrev">PREV</div>
                <div class="part_image_item" v-if="imagePartList.length == 0">NO DATA</div>
                <div class="part_image_item" v-for="item in imagePartList" :key="item.id">
                  <img crossorigin="anonymous" @click="handleAddSvg(item.image)" :src="item.image" alt />
                </div>
                <div :class="hasNext ? 'part_image_item' : 'part_image_item disable'" @click="handlePageNext">NEXT</div>
              </div>
              <div class="panel_item">
                <!-- <h4>SIGN LISTS</h4> -->
                <div class="component_list_container">
                  <template v-if="dataJson.objects">
                    <template v-for="(object, index) in dataJson.objects">
                      <div class="mb20" :key="index">
                        <ComponentSvg
                          :object="object"
                          @svgColorChange="handleSetSvgColor"
                          @handleRemove="handleRemove"
                        ></ComponentSvg>
                      </div>
                    </template>
                  </template>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-card>
        <div>
          <el-button
            :class="isClickAble ? 'sub_btn_c' : 'sub_btn_c_disable'"
            :loading="btnLoading"
            style="margin-top:20px"
            size="medium"
            type="danger"
            @click="handleDone"
            >FINISH DESIGN</el-button
          >
        </div>
      </div>
      <!-- </el-col>
      </el-row> -->
    </div>
    <!-- <div class="svg_con">
      <localSvg></localSvg>
    </div>-->
  </div>
</template>

<script>
// import { fabric } from 'fabric';
import { v4 as uuidv4 } from 'uuid';
// import 'fabric-customise-controls';
// import HelloWorld from '@/components/HelloWorld.vue';
import ColorListComponent from '@/components/ColorList.vue';
import ComponentText from '@/components/ComponentText.vue';
import ComponentSvg from '@/components/ComponentSvg.vue';
import FontFaceObserver from '@/plugin/fontfaceobserver.js';
import { resolve } from 'url';
import { rejects } from 'assert';

export default {
  name: 'Home',
  components: {
    ColorListComponent,
    ComponentText,
    ComponentSvg,
  },
  data() {
    return {
      name: '',
      canvas: {},
      imagePartList: [],
      catgoryList: [],
      activeName: 'text',
      loading: false,
      colorList: [
        'rgb(250, 250, 250)',
        'rgb(255, 255, 0)',
        'rgb(0, 85, 255)',
        'rgb(255, 0, 140)',
        'rgb(0, 255, 100)',
        'rgb(200, 0, 255)',
        'rgb(0, 255, 255)',
        'rgb(255, 0, 0)',
        'rgb(0, 128, 255)',
      ],
      activePart: '',
      activeText: '',
      activeFontFamily: '',
      json: '',
      tempJson:
        '{"version":"3.6.3","objects":[{"type":"image","version":"3.6.3","originX":"left","originY":"top","left":0,"top":0,"width":800,"height":571,"fill":"rgb(0,0,0)","stroke":null,"strokeWidth":0,"strokeDashArray":null,"strokeLineCap":"butt","strokeDashOffset":0,"strokeLineJoin":"miter","strokeMiterLimit":4,"scaleX":1,"scaleY":1,"angle":0,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"clipTo":null,"backgroundColor":"","fillRule":"nonzero","paintFirst":"fill","globalCompositeOperation":"source-over","transformMatrix":null,"skewX":0,"skewY":0,"crossOrigin":"null","cropX":0,"cropY":0,"src":"/img/bg.64adef30.jpg","filters":[]},{"type":"image","version":"3.6.3","originX":"left","originY":"top","left":44.65,"top":152.54,"width":255,"height":178,"fill":"rgb(0,0,0)","stroke":null,"strokeWidth":0,"strokeDashArray":null,"strokeLineCap":"butt","strokeDashOffset":0,"strokeLineJoin":"miter","strokeMiterLimit":4,"scaleX":0.64,"scaleY":0.64,"angle":338.09,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"clipTo":null,"backgroundColor":"","fillRule":"nonzero","paintFirst":"fill","globalCompositeOperation":"source-over","transformMatrix":null,"skewX":0,"skewY":0,"crossOrigin":"","cropX":0,"cropY":0,"src":"/img/%E5%88%87%E7%89%879.0806b826.png","filters":[{"type":"BlendColor","color":"rgb(255, 96, 214)","mode":"tint","alpha":1},{"type":"Blur","blur":0.1},{"type":"BlendColor","color":"rgb(255, 142, 62)","mode":"tint","alpha":1}]},{"type":"image","version":"3.6.3","originX":"left","originY":"top","left":147.62,"top":233.38,"width":218,"height":316,"fill":"rgb(0,0,0)","stroke":null,"strokeWidth":0,"strokeDashArray":null,"strokeLineCap":"butt","strokeDashOffset":0,"strokeLineJoin":"miter","strokeMiterLimit":4,"scaleX":0.48,"scaleY":0.48,"angle":0,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"clipTo":null,"backgroundColor":"","fillRule":"nonzero","paintFirst":"fill","globalCompositeOperation":"source-over","transformMatrix":null,"skewX":0,"skewY":0,"crossOrigin":"","cropX":0,"cropY":0,"src":"/img/%E5%88%87%E7%89%875.d5a3ff2e.png","filters":[{"type":"BlendColor","color":"rgb(255, 96, 214)","mode":"tint","alpha":1},{"type":"Blur","blur":0.1},{"type":"BlendColor","color":"rgb(61, 45, 242)","mode":"tint","alpha":1},{"type":"BlendColor","color":"rgb(157, 200, 255)","mode":"tint","alpha":1},{"type":"BlendColor","color":"rgb(133, 57, 255)","mode":"tint","alpha":1}]},{"type":"image","version":"3.6.3","originX":"left","originY":"top","left":176.2,"top":187.8,"width":252,"height":168,"fill":"rgb(0,0,0)","stroke":null,"strokeWidth":0,"strokeDashArray":null,"strokeLineCap":"butt","strokeDashOffset":0,"strokeLineJoin":"miter","strokeMiterLimit":4,"scaleX":0.41,"scaleY":0.41,"angle":0,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"clipTo":null,"backgroundColor":"","fillRule":"nonzero","paintFirst":"fill","globalCompositeOperation":"source-over","transformMatrix":null,"skewX":0,"skewY":0,"crossOrigin":"","cropX":0,"cropY":0,"src":"/img/%E5%88%87%E7%89%871.8b248be0.png","filters":[{"type":"BlendColor","color":"rgb(255, 96, 214)","mode":"tint","alpha":1},{"type":"Blur","blur":0.1},{"type":"BlendColor","color":"rgb(89, 245, 103)","mode":"tint","alpha":1},{"type":"BlendColor","color":"rgb(255, 220, 0)","mode":"tint","alpha":1}]},{"type":"image","version":"3.6.3","originX":"left","originY":"top","left":251,"top":314,"width":376,"height":180,"fill":"rgb(0,0,0)","stroke":null,"strokeWidth":0,"strokeDashArray":null,"strokeLineCap":"butt","strokeDashOffset":0,"strokeLineJoin":"miter","strokeMiterLimit":4,"scaleX":0.39,"scaleY":0.39,"angle":0,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"clipTo":null,"backgroundColor":"","fillRule":"nonzero","paintFirst":"fill","globalCompositeOperation":"source-over","transformMatrix":null,"skewX":0,"skewY":0,"crossOrigin":"","cropX":0,"cropY":0,"src":"/img/%E5%88%87%E7%89%874.37709ad8.png","filters":[{"type":"BlendColor","color":"rgb(255, 96, 214)","mode":"tint","alpha":1},{"type":"Blur","blur":0.1},{"type":"BlendColor","color":"rgb(89, 245, 103)","mode":"tint","alpha":1}]}]}',

      addingText: '',
      fontList: [
        'Aoox',
        'Autoguard',
        'BadScript',
        'BaristaScript',
        'Bath',
        'BEYNO',
        'BreakFill',
        'BukhariScript',
        'Dobby',
        'Fitalia',
        'Garden',
        'LondrinaOutline',
        'LoveloLine',
        'Marske',
        'Megrim',
        'Neoneon',
        'Paralines',
        'PoiretOne',
        'Prince',
        // 'SEGOESC',
        'Snow',
        'Waxe',
      ],
      bgList: ['/bg/black-wall2.jpg', '/bg/red-wall.jpg', '/bg/white-wall.jpg', '/bg/wooden-wall.jpg'],
      pagination: {
        current: 0,
        limit: 10,
        total: null,
      },
      keyword: '',
      catgory: '',

      activeObject: null,
      dataJson: {},
      hasPrev: false,
      hasNext: true,
      btnLoading: false,
      activeImageTag: 'all',
      isClickAble: false,
    };
  },
  async mounted() {
    if (fabric.isWebglSupported()) {
      fabric.textureSize = fabric.maxTextureSize;
    }
    const ref = this.$refs.canvas;
    this.canvas = new fabric.Canvas(ref, { selection: false });
    await this.loadBg();
    this.getCatgory();
    this.getList();
    this.config();
    this.initClickEvent();
    this.getProductInfo();
    this.loadAndUseBg(this.bgList[0]);
    window.addEventListener('resize', e => {
      this.windowSize();
    });
    this.windowSize();
  },
  watch: {
    canvas: {
      handler(val) {
        this.dataJson = val.toObject(['id', 'url']);
        if (this.dataJson.objects.length > 0) {
          this.isClickAble = true;
          return;
        }
        this.isClickAble = false;
        // console.log(this.dataJson);
      },
      deep: true,
      // immediate: true,
    },
    pagination: {
      handler(val) {
        if ((this.pagination.current + 1) * this.pagination.limit >= this.pagination.total) {
          this.hasNext = false;
        } else {
          this.hasNext = true;
        }
        if (this.pagination.current <= 0) {
          this.hasPrev = false;
        } else {
          this.hasPrev = true;
        }
      },
      deep: true,
    },
  },
  methods: {
    windowSize() {
      const w = document.body.clientWidth;
      if (w < 550) {
        const percent = w / 550;
        document.getElementsByClassName('left')[0].style.width = '100%';
        // document.getElementsByClassName('editor_container')[0].style.zoom = percent;
        this.canvas.setZoom(percent);
        document.getElementsByClassName('editor_container')[0].style.height = 550 * percent + 'px';
        this.canvas.renderAll();
        console.log(this.canvas.getZoom());
        document.getElementsByClassName('page_container')[0].style.padding = 0;
        document.getElementsByClassName('main_width')[0].style.padding = 0;
        document.getElementsByClassName('right')[0].style.width = '100%';
        document.getElementsByClassName('right')[0].style.minWidth = 'auto';
      } else {
        document.getElementsByClassName('left')[0].style.width = '550px';
        document.getElementsByClassName('editor_container')[0].style.zoom = 1;
        document.getElementsByClassName('page_container')[0].style.padding = '0 20px';
        document.getElementsByClassName('main_width')[0].style.padding = '0 10px;';
        document.getElementsByClassName('right')[0].style.width = '40%';
        document.getElementsByClassName('right')[0].style.minWidth = '550px';
      }
    },
    handlePagePrev() {
      if (this.pagination.current <= 0) {
        this.hasPrev = false;
        return;
      }
      this.pagination.current--;
      this.getList(this.activeImageTag);
    },
    handlePageNext() {
      if ((this.pagination.current + 1) * this.pagination.limit >= this.pagination.total) {
        return;
      }
      this.pagination.current++;
      this.getList(this.activeImageTag);
    },

    async handleDone() {
      if (!this.isClickAble) return;
      this.btnLoading = true;
      const zoom = this.canvas.getZoom();
      this.canvas.setZoom(1);
      const base64 = this.canvas.toDataURL();
      const url = await this.uploadBase64(base64);
      this.canvas.setZoom(zoom);
      this.btnLoading = false;
      // window.location =
      //   `/products/custom-neon-sign?_pos=1&_sid=78fca33af&_ss=r&url=` + url;
      window.parent.postMessage({ url }, 'https://alphaneon-test.myshopify.com/');
      window.parent.postMessage({ url }, '*');
    },

    async getProductInfo() {
      if (this.$route.params.id == 'new') return;
      const res = await this.$axios.get(`/custom/one?id=${this.$route.params.id}`);
      this.canvas.loadFromJSON(JSON.parse(res.data.json));
    },
    async save() {
      if (!this.name) {
        this.$message({
          type: 'error',
          message: '请输入产品标题',
        });
        return;
      }
      const base64 = this.canvas.toDataURL();
      const url = await this.uploadBase64(base64);
      const res = await this.$axios.post(`/custom/save`, {
        data: {
          name: this.name,
          json: JSON.stringify(this.dataJson),
          preview: url,
        },
      });
      if (res.data.code == 0) {
        this.$message({
          type: 'warning',
          message: res.data.msg,
        });
        return;
      }
      if (res.data.id) {
        this.$message({
          type: 'success',
          message: '保存成功',
        });
      }
    },
    uploadBase64(base64) {
      // const buffer = Buffer.from(base64);
      return new Promise(async (resolve, reject) => {
        const buffer = Buffer.from(base64.replace(/^data:image\/\w+;base64,/, ''), 'base64');
        const res = await this.$axios.get('/s3/sign', {
          params: {
            path: 'custom/',
            objectName: 'custom_preview_' + uuidv4(),
            contentType: 'image/png',
          },
        });
        // console.log(res);
        if (res.data.filename) {
          const uploadResult = await this.$axios.put(res.data.signedUrl, buffer, {
            headers: {
              'Content-Type': 'image/png',
              ContentEncoding: 'base64',
            },
          });
          if (uploadResult.status == 200) {
            resolve(res.data.publicUrl);
          }
          reject(null);
        }
      });
    },
    /**
     * 根据当前 JSON 渲染操作组件
     */
    renderComponentByJson() {},
    /**
     * 初始化组件点击事件
     */
    initClickEvent() {
      const self = this;
      this.canvas.on('mouse:down', e => {
        this.activeObject = e.target;
      });
      fabric.Canvas.prototype.getItemById = function(id) {
        var object = null,
          objects = self.canvas.getObjects();
        for (var i = 0, len = this.size(); i < len; i++) {
          if (objects[i].id && objects[i].id === id) {
            return objects[i];
            break;
          }
        }
        return null;
      };
    },
    /**
     * 添加文本组件值画布
     */
    handleAddText() {
      const textbox = new fabric.Textbox(this.addingText, {
        fill: this.colorList[0],
        fontSize: 40,
        shadow: `${this.colorList[0]} 0 0 10px`,
        left: 100,
        top: 250,
        width: 350,
        stroke: this.colorList[0],
        strokeWidth: 0.5,
        id: uuidv4(),
        textAlign: 'center',
      });
      this.canvas.add(textbox).setActiveObject(textbox);
      textbox.setControlsVisibility({
        mt: false,
        mb: false,
        // ml: false,
        // mr: false,
      });
      this.canvas.renderAll();
      this.loadAndUse('Bath');
      this.activeObject = textbox;
    },
    /**
     * 添加 Svg 指画布和组件
     * @param {String} SVG图片远程地址
     */
    async handleAddSvg(url) {
      this.loading = true;
      const oImg = await this._addSvgToCanvas(url);
      oImg.set({
        id: uuidv4(),
        url,
      });
      // oImg.setControlsVisibility({
      //   mt: false,
      //   mb: false,
      //   ml: false,
      //   mr: false,
      // });
      this.canvas.add(oImg).setActiveObject(oImg);
      this.canvas.renderAll();
      this.loading = false;
    },
    handleRemove(id) {
      const object = this.canvas.getItemById(id);
      this.canvas.remove(object);
    },
    /**
     * 文本更改
     * @param {String} 文本内容
     */
    handleTextChange(obj) {
      const object = this.canvas.getItemById(obj.id);
      object.set('text', obj.val);
      this.canvas.renderAll();
    },
    /**
     * 字体变更
     * @param {String} 字体名称
     */
    handleFontFamilyChange(obj) {
      const object = this.canvas.getItemById(obj.id);
      object.set('fontFamily', obj.val);
      this.canvas.renderAll();
    },
    /**
     * 文本颜色更改
     * @param {String} 色值 RGB/HEX
     */
    handleFontColorChange(val) {
      // this.activeObject.set('fontFamily', val);
      // this.canvas.renderAll();
      this.handleSetColor(val);
    },
    /**
     * 文本字间距更改
     * @param {String} 字间距比例
     */
    handleFontCharSpacingChange(val) {
      this.activeObject.set('charSpacing', val);
      this.activeObject.initDimensions();
      this.canvas.renderAll();
    },
    /**
     * 文本更改
     * @param {String} 文本内容
     */
    handleSetColor(obj) {
      const activeObject = this.canvas.getItemById(obj.id);
      if (!activeObject) return;
      if (activeObject == 'undefined') return;
      if (activeObject.type == 'image') {
        this.changeImageColorFilter(activeObject, obj.val);
      } else if (activeObject.type == 'textbox') {
        this.changeTextColorFilter(activeObject, obj.val);
      }
    },
    handleSetSvgColor(obj) {
      const object = this.canvas.getItemById(obj.id);

      const color = obj.val;
      // this._changeSvgColor(object, color);
      // object.set({
      //   fill: '#fff',
      //   stroke: color,
      //   strokeWidth: 1,
      //   shadow: `${color} 0 0 30px`,
      // });
      const config = {
        fill: color,
        stroke: color,
        strokeWidth: 1,
        // shadow: `#fff 0 0 30px`,
      };
      object.set({ ...config, shadow: `${color} 0 0 30px` });
      if (object._objects) {
        object._objects.forEach(item => {
          item.set({ ...config });
        });
      }
      this.canvas.renderAll();
    },
    loadAndUse(font) {
      const self = this;
      const myfont = new FontFaceObserver(font);
      myfont
        .load()
        .then(function() {
          // when font is loaded, use it.
          self.canvas.getActiveObject().set('fontFamily', font);
          self.canvas.requestRenderAll();
        })
        .catch(function(e) {
          console.log(e);
          alert('font loading failed ' + font);
        });
    },
    loadAndUseBg(bg) {
      const self = this;
      fabric.Image.fromURL(bg, function(img) {
        // add background image
        self.canvas.setBackgroundImage(img, self.canvas.renderAll.bind(self.canvas), {
          scaleX: self.canvas.width / img.width,
          scaleY: self.canvas.height / img.height,
        });
      });
    },
    changeImageColorFilter(object, color) {
      const filterColor = new fabric.Image.filters.BlendColor({
        // color: color,
        color: '#FFF',
        mode: 'tint',
        // alpha: 0.9,
        // scale: { x: 0.5, y: 0.5 },
      });
      object.filters.push(filterColor);
      object.applyFilters();

      const shadow = new fabric.Shadow({
        color: color,
        blur: 40,
      });

      object.setShadow(shadow);
      this.canvas.renderAll();
    },
    changeTextColorFilter(object, color) {
      // debugger;
      object.set('shadow', `${color} 0 0 10px`);
      object.set('stroke', `${color}`);
      object.set('fill', `${color}`);
      this.canvas.renderAll();
    },
    loadBg() {
      return;
      return new Promise((resolve, reject) => {
        fabric.Image.fromURL(
          require('@/assets/bg.jpg'),
          res => {
            res.selectable = false;
            this.canvas.add(res);
            resolve();
          },
          { crossOrigin: 'null' }
        );
      });
    },
    /**
     * 添加图片至画布
     */
    _addImageToCanvas(url) {
      return new Promise((resolve, reject) => {
        const tempImage = new Image();
        tempImage.crossOrigin = 'Anonymous';
        tempImage.src = url;
        tempImage.onerror = e => {
          console.log('image load error:', e);
        };
        tempImage.onload = e => {
          const image = new fabric.Image(tempImage, {
            scaleX: 0.5,
            scaleY: 0.5,
            left: 100,
            top: 100,
          });
          this.canvas.add(image);
          resolve(image);
        };

        // fabric.Image.fromURL(
        //   url,
        //   oImg => {
        //     oImg.scaleX = 0.5;
        //     oImg.scaleY = 0.5;
        //     this.canvas.add(oImg);
        //     this.canvas.calcOffset();
        //     resolve(oImg);
        //   },
        //   { crossOrigin: 'anonymous' }
        // );
      });
    },

    _addSvgToCanvas(url) {
      return new Promise((resolve, reject) => {
        fabric.loadSVGFromURL(url, (object, options) => {
          // object = this._changeSvgColor(object, this.colorList[0]);
          const svg = fabric.util.groupSVGElements(object, options);
          svg.set({
            scaleX: 0.5,
            scaleY: 0.5,
            shadow: `${this.colorList[0]} 0 0 30px`,
            left: 100,
            top: 100,
          });
          // console.log(svg);
          resolve(svg);
        });
      });
    },

    _changeSvgColor(object, color) {
      if (object instanceof Array) {
        object.forEach(item => {
          item.fill = color;
          item.stroke = color;
          item.strokeWidth = 1;
          // item.shadow = `${this.colorList[0]} 0 0 10px`;
        });
      } else if (object instanceof Object) {
        object.fill = color;
        object.stroke = color;
        object.strokeWidth = 1;
        // object.shadow = `${this.colorList[0]} 0 0 10px`;
      }
      return object;
    },

    loadSvg() {},
    loadFromJSON() {
      // this.canvas.loadFromJSON(this.json ? this.json : this.tempJson);
    },

    // 获取图案组件列表
    async getList(index) {
      if (typeof index == 'undefined') {
        this.activeImageTag = 'all';
      } else {
        this.activeImageTag = index;
      }
      // this.activeImageTag = index == 'all' || typeof index == 'undefined' ? 'all' : index;
      const offset = this.pagination.current * this.pagination.limit;
      const res = await this.$axios.get(
        `/assets/list?offset=${offset}&limit=${this.pagination.limit}&keyword=${this.keyword}&catgory=${this.catgory}`
      );
      this.imagePartList = res.data.rows;
      this.pagination.total = res.data.count;
    },

    // 获取分类列表
    async getCatgory() {
      const res = await this.$axios.get('/catgory');
      if (res.data.code == 1) {
        this.catgoryList = res.data.data.rows;
      }
    },

    /**
     * Fabricjs 配置，替换图标
     */
    config: function() {
      let self = this;
      // Basic settings
      fabric.Object.prototype.customiseCornerIcons({
        settings: {
          borderColor: '#ffffff',
          cornerSize: 10,
          cornerBackgroundColor: '#ffffff',
          hasRotatingPoint: false,
          cornerShape: 'circle',
          cornerPadding: 20,
          padding: 20,
        },
        // tl: {
        //   icon: require('@/assets/icons/lt.svg'),
        // },
        // tr: {
        //   icon: require('@/assets/icons/rt.svg'),
        // },
        // bl: {
        //   icon: require('@/assets/icons/remove.svg'),
        // },
        // br: {
        //   icon: require('@/assets/icons/rb.svg'),
        // },
        // ml: {
        //   icon: require('@/assets/icons/ml.svg'),
        // },
        // mr: {
        //   icon: require('@/assets/icons/mr.svg'),
        // },
        // mt: {
        //   icon: require('@/assets/icons/mt.svg'),
        // },
        // mb: {
        //   icon: require('@/assets/icons/mb.svg'),
        // },
      });
      fabric.Canvas.prototype.customiseControls({
        // tl: {
        //   action: 'rotate',
        //   cursor: require('@/assets/icons/rotate_cursor.svg'),
        // },
        // bl: {
        //   action: function(e, target) {
        //     self.canvas.remove(target);
        //     self.canvas.renderAll();
        //   },
        //   cursor: 'pointer',
        // },
      });
    },
  },
};
</script>

<style lang="less">
// @import (css) url('https://fonts.googleapis.com/css?family=Pacifico|PT Sans|Quicksand|Inconsolata');
@media screen and (max-width: 640px) {
  .asset_item {
    min-width: 200px;
    img {
      min-height: auto;
    }
  }
}
.home {
  canvas {
    // background: #000;
  }
  .category_list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    button {
      margin-left: 0 !important;
      margin-right: 10px;
      margin-bottom: 10px;
    }
  }
  .editor_container {
    float: left;
    background: #000;
    border-radius: 3px;
    box-shadow: 2px 2px 7px 0px #00000040;
    overflow: hidden;
  }
  .part_image_container {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    width: 100%;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    padding: 10px;
    margin-bottom: 20px;
    border-radius: 3px;

    .part_image_item {
      // background: rebeccapurple;
      border: 1px solid #dcdfe6;
      box-sizing: border-box;
      border-radius: 3px;
      margin-bottom: 10px;
      cursor: pointer;
      margin-right: 5px;
      margin-left: 5px;
      background: #333;
      color: #fff;
      width: 70px;
      height: 70px;
      text-align: center;
      line-height: 60px;
      padding: 5px;
      box-sizing: border-box;
      user-select: none;
      // span {
      //   display: block;
      //   width: 80px;
      //   height: 80px;
      //   background-color: red;
      //   background-size: contain;
      //   background-repeat: no-repeat;
      //   background-blend-mode: lighten;
      // }
      &.disable {
        color: #999;
        cursor: not-allowed;
      }
      img {
        display: block;
        width: 58px;
        height: 58px;
        // mix-blend-mode: color;
        object-fit: contain;
      }
    }
  }
}
.panel_item {
  margin-bottom: 20px;
  h4 {
    margin-bottom: 10px;
  }
}
.color_container {
  display: flex;
  justify-content: space-between;
  .color_item {
    span {
      display: block;
      width: 40px;
      height: 40px;
      cursor: pointer;
    }
  }
}
.action_container {
  margin-top: 20px;
  display: flex;
  span {
    display: block;
    width: 100px;
    height: 30px;
    cursor: pointer;
    background: #333;
    text-align: center;
    color: #fff;
    line-height: 30px;
    margin-bottom: 10px;
  }
  textarea {
    display: block;
    width: 100%;
    height: 200px;
  }
}
.component_list_container {
  // max-height: 500px;
  // overflow-y: scroll;
}
// svg {
//   background-color: #ccc;
//   width: 500px;
//   padding: 20px;
// }

// svg.filter {
//   // width: 0;
//   padding: 0;
//   opacity: 0;
// }

// text {
//   font-family: Helvetica, Arial, sansserif;
//   // font-size: 100px;
//   // font-weight: 900;
//   fill: white;
//   filter: url(#red-glow);
// }
// polygon,
// path,
// circle {
//   fill: white;
//   filter: url(#red-glow);
// }
.sub_btn_c {
  background-color: #b963fd !important;
  border-color: #b963fd !important;
  padding: 16px 50px;
  span {
    font-size: 16px;
  }
}
.sub_btn_c_disable {
  background-color: #c1c1c1 !important;
  border-color: #c1c1c1 !important;
  padding: 16px 50px;
  cursor: not-allowed;
  span {
    font-size: 16px;
  }
}
.main_container_editor {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .left {
    width: 550px;
  }
  .right {
    width: 40%;
    min-width: 550px;
  }
}
.bg_container_c {
  // width: 80%;
  // display: flex;
  // justify-content: space-between;
  background: #fff;
  padding: 10px 0;
  clear: both;
  position: relative;
  z-index: 1000;
  .bg_item {
    cursor: pointer;
    width: 80px;
    height: 80px;
    display: inline-block;
    margin-right: 10px;
    img {
      display: block;
      width: 100%;
    }
  }
}
</style>
